<style scoped lang="less">
    .singleRowProduct-module{
        
        .product-list{

            display: flex;
            flex-wrap: wrap;
            justify-content: space-evenly;

            .product-item{

                width: 170px;
                background: #fff;
                padding-bottom: 20px;
                margin-bottom: 10px;

                img{
                    width: 170px;
                    height: 170px;
                    border: 1px solid #ddd;
                }

                .name{
                    margin: 5px 10px 10px;
                    font-size: 14px;
                    
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                
                .pro-info{
                    display: flex;
                    margin: 0 10px;

                    .left{
                        flex: 1 1 auto;
                        color: #1890ff;
                        font-weight: bold;
                        font-size: 16px;

                        .old{
                            font-size: 16px;
                            color: #ccc;
                            font-weight: 400;
                            text-decoration: line-through;
                        }
                    }

                    .btn-type-1{
                        flex: 0 0 auto;
                        width: 60px;
                        height: 24px;
                        line-height: 24px;
                        font-size: 12px;
                        color: #fff;
                        background: #1890ff;
                        text-align: center;
                        border-radius: 18px;
                    }

                    .btn-type-2{
                        flex: 0 0 auto;
                        width: 60px;
                        height: 24px;
                        line-height: 24px;
                        font-size: 12px;
                        color: #1890ff;
                        border: 1px solid #1890ff;
                        text-align: center;
                    }

                    .btn-type-3{
                        flex: 0 0 auto;
                        width: 24px;
                        height: 24px;
                        padding-top: 5px;
                        color: #fff;
                        background: #1890ff;
                        border-radius: 100%;
                        text-align: center;
                    }
                }
            }
            
        }
        
    }
    .haveSpace{
        margin-bottom: 20px;
    }
</style>

<template>
    <div class="singleRowProduct-module"  :class="{haveSpace: !data.hideSpace}">
        <module-name :name="name"></module-name>
        <controler @edit="edit();data.editVisible=!data.editVisible" @moveUp="$emit('moveUp')" :visible="data.visible" @moveDown="$emit('moveDown')" @remove="$emit('remove')" ></controler>
        <edit :data="data" @submit="$emit('submit')" :visible="data.editVisible" :name="name" @close="data.editVisible=false"  />
        
        <div @click="edit();data.visible=true">
            <div class="product-list" v-if="!data.list.length">
                <div class="product-item">
                    <img :src="normalData.url" />
                    <p class="name">{{normalData.name}}</p>
                    <div class="pro-info">
                        <div class="left">
                            ￥{{normalData.price}}
                        </div>
                        <div class="btn-type-1" v-if="data.btnType===1">立即购买</div>
                        <div class="btn-type-2" v-if="data.btnType===2">立即购买</div>
                        <div class="btn-type-3" v-if="data.btnType===3"><Icon type="ios-cart-outline" size=16></Icon></div>
                    </div>
                </div>
                <div class="product-item">
                    <img :src="normalData.url" />
                    <p class="name">{{normalData.name}}</p>
                    <div class="pro-info">
                        <div class="left">
                            ￥{{normalData.price}}
                        </div>
                        <div class="btn-type-1" v-if="data.btnType===1">立即购买</div>
                        <div class="btn-type-2" v-if="data.btnType===2">立即购买</div>
                        <div class="btn-type-3" v-if="data.btnType===3"><Icon type="ios-cart-outline" size=16></Icon></div>
                    </div>
                </div>
            </div>
            <div class="product-list" v-else>
                <div class="product-item" :key="index" v-for="(item, index) in data.list">
                    <img :src="$store.state.pageManageConfig.imghost+item.ImgUrl" />
                    <p class="name">{{item.Name}}</p>
                    <div class="pro-info">
                        <div class="left">
                            ￥{{item.Price}}
                        </div>
                        <div class="btn-type-1" v-if="data.btnType===1">立即抢购</div>
                        <div class="btn-type-2" v-if="data.btnType===2">立即抢购</div>
                        <div class="btn-type-3" v-if="data.btnType===3"><Icon type="ios-cart-outline" size=16></Icon></div>
                    </div>
                </div>
                <div class="product-item" v-if="data.list.length%2" style="background: transparent">
                </div>
            </div>
        </div>


    </div>
</template>

<script>

import moduleName from '../../moduleName';
import controler from '../../controler';
import edit from './edit';



export default {
    name: 'normal-module',
    components: {
        moduleName,
        controler,
        edit,
        
    },
    props: {
        name: {
            type: String,
            default: ''
        },
        data: {
            type: Object,
            default: ()=>{
                return {}
            }
        },
        
    },
    data () {
        return {
            
            btnType: 1, //按钮三种样式
            normalData: {
                url: this.$store.state.pageManageConfig.staticImage.noPic,
                name: '此处是商品名称-此处是商品名称',
                price: 99.00,
                marketPrice: 100.00,
            }
        };
    },
    methods: {
        edit(){
            this.$emit('visibleChange', this.data.visible)
        },
        
        close(){
            this.$emit('visibleChange', false)
        }

    },
    mounted () {
    },
    watch: {
        
    }
};
</script>

